import * as angular from "angular";
import * as _ from "lodash";


export class TimelineService {
  constructor() {
  }

  getTimelineRange(routes) {
    const range = {
      from: undefined,
      to: undefined
    };

    if (!_.isArray(routes)) {
      routes = [routes];
    }

    _.forEach(routes, (route) => {
      _.forOwn(route.analysis, (value, key) => {
        range.from = range.from === undefined || range.from > value.eta ? value.eta : range.from;
        range.to = range.to === undefined || range.to < value.eta ? value.eta : range.to;
      })
    });
    return range;
  }

  getMovedTaskPayload(serviceIds, fromRouteId, toRouteId, fromOrderedIds, toOrderedIds) {
    if (!toRouteId) {
      // Remove Task In Route
      return [
        {
          id: fromRouteId,
          remove: serviceIds
        }
      ]
    } else if (fromRouteId === toRouteId) {
      // Move Task In Route
      return [
        {
          id: fromRouteId,
          order: fromOrderedIds
        }
      ]
    } else if(!fromRouteId && !!toRouteId) {
      // Add To Route
      return  [
        {
          id: toRouteId,
          add: serviceIds,
          order: toOrderedIds
        }
      ]
    } else {
      // Move Between Routes
      return [
        {
          id: fromRouteId,
          remove: serviceIds
        },
        {
          id: toRouteId,
          add: serviceIds,
          order: toOrderedIds
        }
      ]
    }
  }
}

angular
  .module('bringoz.admin.commons')
  .service('TimelineService', TimelineService);
